import { Box, makeStyles } from "@material-ui/core";
import { SvgIconComponent } from "@material-ui/icons";
import DefaultIcon from "@material-ui/icons/ViewList";
import { FC } from "react";

import colors from "../theme/colors";
import { IconFontSize } from "../types/generic.types";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    background: theme.palette.error.main,
    position: "relative",
    right: 8,
    bottom: 0,
    display: "inline-block",
    fontSize: 9,
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
  },
}));

const SidebarIconWrapper: FC<SidebarIconWrapperProps> = ({ IconComponent, size = "default", showBullet }) => {
  const classes = useStyles({});

  return (
    <Box display="flex" position="relative">
      {IconComponent ? (
        <IconComponent fontSize={size} style={{ color: colors.menu.icon }} />
      ) : (
        <DefaultIcon fontSize={size} style={{ color: colors.menu.icon }} />
      )}
      {showBullet && <div className={classes.icon} />}
    </Box>
  );
};

interface SidebarIconWrapperProps {
  IconComponent: SvgIconComponent;
  size?: IconFontSize;
  showBullet: boolean;
}

export default SidebarIconWrapper;
